<template>
    <div>
        <br /><br />
        <br /><br />
        <div class="form-row">
            <div class="controls mb-1">
                <input id="embalaje" type="checkbox" v-model="$bus.formulario.facturaCompleta">
                <label class="text--s" for="embalaje" style="font-family: Heebo; font-weight: normal">¿Va a necesitar factura no simplificada?</label>
            </div>
        </div>
        <div v-if="$bus.formulario.facturaCompleta" class="form-row" data-is-visible="true">
            <h1 style="font-family: Heebo; font-size: 22px; color: black; font-weight: normal ">¿Quieres usar la misma dirección para la facturación?</h1>
            <br /><br />
            <br /><br />
            <div class="controls mb-1">
                <input id="rb_factura_si" type="radio" name="radio-group-factura" v-model="$bus.formulario.igualFacturacion" :value="true">
                <label class="text--s" for="rb_factura_si" style="font-family: Heebo; font-weight: normal">Sí</label>
            </div>
            <div class="controls">
                <input id="rb_factura_no" type="radio" name="radio-group-factura" v-model="$bus.formulario.igualFacturacion" :value="false">
                <label class="text--s" for="rb_factura_no" style="font-family: Heebo; font-weight: normal">No</label>
            </div>
        </div>
        <template v-if="!$bus.formulario.igualFacturacion">
        
                <table>
                    <tr>
                        <td>
                            <div class="form-row">
                                <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                                    <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-80 elementor-field-required">
                                        <input style="color: #606060" v-model="localCP" maxlength="5" type="number" name="form_fields[company]" id="form-field-company" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Código postal *">
                                    </div>
                                </div>
                                <p class="error mt-1 text--s" style="font-family: Heebo; font-weight: normal">{{ facturacion.zipcodeError }}</p>
                            </div>
                        </td>
                        <td>
                            <div class="form-row">
                                <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                                    <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-80 elementor-field-required">
                                        <input style="color: #606060" v-model="facturacion.address" maxlength="40" type="text" name="form_fields[company]" id="form-field-company" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Dirección, número, piso y escalera *">
                                    </div>
                                </div>
                                <p class="error mt-1 text--s" style="font-family: Heebo; font-weight: normal">{{ facturacion.addressError }}</p>
                            </div>

                        </td>
                    </tr>
                    <tr>
                        <td>


                            <div class="form-row">

                                <label style="font-family: Heebo; font-weight: normal; font-size: 14px">Población *</label>

                                <div v-if="mostrarInput" class="input-item">
                                    <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                                        <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-80 elementor-field-required">
                                            <input style="color: #9BA19D;" v-model="poblacion" maxlength="40" type="text" name="form_fields[company]" id="form-field-company" class="elementor-field elementor-size-sm  elementor-field-textual"
                                                   placeholder="Se habilita al introducir un código postal válido">

                                        </div>
                                    </div>

                                </div>

                                <div v-else class="input-item">
                                    <div class="input input--select input--s">
                                        <select v-model="poblacion">
                                            <option v-for="pob in poblaciones" :key="pob.POBLACION" :value="pob.POBLACION" style="font-family: Heebo; font-weight: normal; color: #9BA19D;">{{ pob.POBLACION }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="form-row">
                                <label style="font-family: Heebo; font-weight: normal; font-size: 14px">Provincia *</label>
                                <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                                    <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-80 elementor-field-required">
                                        <input style="color: #9BA19D;" v-model="provincia" maxlength="40" type="text" :readonly="readonly" name="form_fields[company]" id="form-field-company" class="elementor-field elementor-size-sm  elementor-field-textual"
                                               placeholder="Se autocompleta al seleccionar una población">
                                    </div>
                                </div>

                            </div>
                        </td>
                    </tr>
                </table>
          

        </template>
    </div>
</template>

<script>
    export default {
        props: {
            facturacion: Object,
        },

        computed: {
            hayCPs() { return this.$bus.CPs.length > 0 },
            //Poblacion y provincia
            mostrarInput() {
                return (
                    this.facturacion.town != "" ||
                    this.localCP.length < 5 ||
                    !this.hayCPs ||
                    (this.esEmpresa && !this.cpEditado)
                );
            },
            readonly() { return this.hayCPs || (this.esEmpresa && !this.cpEditado) },
            backgroundColor() { return this.readonly ? 'background-color:LightGrey;' : '' },
            localCP: {
                get() { return this.facturacion.zipcode },
                set(valor) { this.facturacion.zipcode = valor }
            },
            poblacion: {
                get() {
                    if (this.hayCPs && this.facturacion.town == '') return 'Se habilita al introducir un codigo postal valido'
                    return this.facturacion.town
                },
                set(valor) {
                    if (this.hayCPs && valor != '') this.provincia = this.poblaciones.filter(x => (x.POBLACION == valor))[0].PROVINCIA
                    this.facturacion.town = valor
                }
            },
            provincia: {
                get() {
                    if (this.hayCPs && this.facturacion.province == '') return 'Se autocompleta al seleccionar una población'
                    return this.facturacion.province
                },
                set(valor) { this.facturacion.province = valor }
            }
        },

        data: () => ({
            cpEditado: false,
            poblaciones: []
        }),

        watch: {
            localCP(nuevoCP) {
                this.cpEditado = true
                if (this.hayCPs) {
                    if (nuevoCP.length == 5) this.poblaciones = this.$bus.CPs.filter(x => x.CP == nuevoCP)
                    else {
                        this.poblaciones = []
                        this.facturacion.town = ''
                        this.facturacion.province = ''
                    }
                }
            }
        }
    }
</script>


<style>
    @font-face {
        font-family: 'Heebo';
        src: url('/fonts/heebo-regular.woff');
        font-weight: 400;
    }

    @font-face {
        font-family: 'Heebo';
        src: url('/fonts/heebo-bold.woff');
        font-weight: bold;
    }


    #recogida .v-input__slot {
        border: 0px solid white;
    }
</style>
